import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import classnames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import Wishes from 'components/Wishes';
import MyWillBuys from 'components/MyWillBuys';
import DeleteWishConfirmation from 'components/dialogs/DeleteWishConfirmation';
import EditWish from 'components/dialogs/EditWish';
import Dialogs from 'components/dialogs/Dialogs';
import './App.css';

const drawerWidth = 280;

const styles = theme => ({
  main: {
    flexGrow: 1
  },
  mainPersistent: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth
  },
  mainShiftPersistent: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0
  }
});

class App extends Component {
  render() {
    const { showSidebar, persistentSidebar, classes } = this.props;

    return (
      <div className="App">
        <Sidebar />
        <div className={ classnames(
            "Main",
            [classes.main], {
              [classes.mainPersistent]: persistentSidebar,
              [classes.mainShiftPersistent]: persistentSidebar && showSidebar
            }) }>
          <Header />
          <Route exact path="/" component={ Wishes } />
          <Route path="/willBuy" component={ MyWillBuys } />
        </div>
        <DeleteWishConfirmation />
        <EditWish />
        <Dialogs />
      </div>
    );
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js